export const NumberUtils = {
  data () {
    return {}
  },
  methods: {
    round (num, decimales = 2) {
      var signo = (num >= 0 ? 1 : -1)
      num = num * signo
      if (decimales === 0) { // con 0 decimales
        return signo * Math.round(num)
      }
      // round(x * 10 ^ decimales)
      num = num.toString().split('e')
      num = Math.round(+(num[0] + 'e' + (num[1] ? (+num[1] + decimales) : decimales)))
      // x * 10 ^ (-decimales)
      num = num.toString().split('e')
      return signo * (num[0] + 'e' + (num[1] ? (+num[1] - decimales) : -decimales))
    },
    intlRound (numero) {
      var opciones = {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      }
      return Number(numero).toLocaleString('en', opciones)
    }
  }
}
